var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "Signature_Control"
  }, [_c("div", {
    staticClass: "card_box",
    class: {
      highlighted: _vm.itemA.isHighlighted,
      selected: _vm.itemA.isSelectedShow
    },
    on: {
      mouseover: function ($event) {
        return _vm.highlight(_vm.indexA);
      },
      mouseleave: function ($event) {
        return _vm.removeHighlight(_vm.indexA);
      },
      click: function ($event) {
        return _vm.toggleSelection(_vm.indexA);
      }
    }
  }, [_c("div", {
    staticClass: "nameBox"
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("签名设置区")))]), _vm.itemA.url == "" ? _c("div", {
    staticClass: "Qm_box_a"
  }, [_c("div", {
    staticClass: "singn_tit"
  }, [_vm._v(_vm._s(_vm.$t("请在下方空白区域进行签名动作，完成签名后点击[上传]按钮")))]), _c("div", {
    staticClass: "QM_tit"
  }, [_vm._v(_vm._s(_vm.$t("签名区")))]), _c("div", {
    staticClass: "but_box"
  }, [_c("a-button", {
    attrs: {
      disabled: ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("取消")) + " ")]), _c("a-button", {
    staticStyle: {
      "background-color": "#1890ff",
      color: "#fff"
    },
    attrs: {
      disabled: "",
      type: "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t("上传")) + " ")])], 1)]) : _c("div", {
    staticClass: "Qm_box_a"
  }, [_c("div", {
    staticClass: "singn_tit"
  }, [_vm._v(_vm._s(_vm.$t("请在下方空白区域进行签名动作，完成签名后点击[上传]按钮")))]), _c("div", {
    staticClass: "QM_tit_b"
  }, [_c("img", {
    staticClass: "img_nav",
    attrs: {
      src: _vm.itemA.url
    }
  })]), _c("div", {
    staticClass: "but_box"
  }, [_c("a-button", {
    attrs: {
      disabled: ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("取消")) + " ")]), _c("a-button", {
    staticStyle: {
      "background-color": "#1890ff",
      color: "#fff"
    },
    attrs: {
      disabled: "",
      type: "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t("上传")) + " ")])], 1)])]), _vm.itemA.isSelected ? [_c("control-action", {
    attrs: {
      "current-control-item": _vm.itemA,
      formDataArray: _vm.formDataArrayA,
      "current-control-index": _vm.indexA
    },
    on: {
      relationClick: _vm.relationClick,
      formeClick: _vm.formeClick
    }
  })] : _vm._e()], 2), _vm.itemA.editing ? _c("div", [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.itemA,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav"
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("签名区设置：")))]), _c("signModel", {
    attrs: {
      index: _vm.indexA,
      "form-data-array": _vm.formDataArrayA
    }
  }), _c("div", {
    staticClass: "btn_close",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        return _vm.formeClase(_vm.indexA);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)], 1)])], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };